export const purchaseOrderItemRemarksTemplateCategory = 'purchase_order-item-remarks_template'
export const purchaseOrderCommunicationTemplateCategory = 'purchase_order-communication_template'
